export default __webpack_public_path__ + "static/media/digital1.597a238b.png";